const numberFormatters = new Map<number, Intl.NumberFormat>();

function getNumberFormatter(precision: number): Intl.NumberFormat {
    let formatter = numberFormatters.get(precision);
    if (!formatter) {
        formatter = new Intl.NumberFormat('en-US', {
            minimumFractionDigits: precision,
            maximumFractionDigits: precision,
        });
        numberFormatters.set(precision, formatter);
    }
    return formatter;
}

type MetricFormatConfig = {
    allowedDecimals: number;
    preUnit: string;
    postUnit: string;
};

export function formatMetricValue(
    value: number | null | undefined,
    config: MetricFormatConfig,
): string {
    if (value === undefined || value === null || Number.isNaN(value)) return '-';
    const num = getNumberFormatter(config.allowedDecimals).format(value);
    return `${config.preUnit}${num}${config.postUnit}`;
}
